<template>
  <div class="card card-body rounded-top">
    <component-table
      entityType="presence"
      :actions="actions"
      :columns="columns"
      :data="list"
      :total="count"
      :hideAddButton="true"
      @edit="showEditModal($event.id)"
    />

    <presence-modal :show="showModal" :players="players" :id="idToEdit" @close="hideModal" @update="update" />
  </div>
</template>

<script>
import { mapState } from 'vuex';

import PresenceModal from '@/components/modals/PresenceModal';
import ComponentTable from '@/components/table/Table';
import { listMixin } from '@/mixins/list';
import { EDIT_ACTION } from '@/utils/constants';

// @vuese
// Listy obecności
// @group Presence
export default {
  name: 'presenceList',
  components: { ComponentTable, PresenceModal },
  mixins: [
    listMixin('presences', {
      listError: 'messages.presence.listError',
      getError: 'messages.presence.getError',
      added: 'messages.presence.added',
      addError: 'messages.presence.addError',
      updated: 'messages.presence.updated',
      updateError: 'messages.presence.updateError',
      deleteConfirm: 'messages.presence.deleteConfirm',
      deleted: 'messages.presence.deleted',
      deleteError: 'messages.presence.deleteError'
    })
  ],
  data() {
    return {
      columns: [
        { name: 'scheduleContainerName', displayName: 'columns.scheduleContainerName' },
        { name: 'date', displayName: 'columns.date' },
        { name: 'hour', displayName: 'columns.hour' },
        { name: 'minute', displayName: 'columns.minute' }
      ],
      actions: [EDIT_ACTION]
    };
  },
  computed: {
    ...mapState({
      list: state =>
        state.presences.list.map(item => ({ ...item, scheduleContainerName: item.scheduleContainer.name })),
      count: state => state.presences.count,
      players: state => state.team.player.list
    })
  }
};
</script>
